import React, { useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ProductQuickViewModal from '../PlpSection/ProductQuickViewModal';
import AddToCartSuccessModal from '../PlpSection/AddToCartSuccessModal';
import AddShoppingListModal from '../PlpSection/AddShoppingListModal';
import useStateRef from 'react-usestateref';
import DefaultContent from '../TargeterContainer/DefaultContent';
import { DEFAULT_IMAGE_140 } from '../../middleware/types'
import { useSelector } from 'react-redux';

const Product = (props) => {
  const [featuredItems, setFeaturedItems] = useState(props.containerObject && props.containerObject.results ? props.containerObject.results : "")
  const [containerObject, setContainerObject] = useState(props.containerObject ? props.containerObject : "");
  const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
  const [quickView, setQuickView] = useState(containerObject.attributes && containerObject.attributes.hideQuickView ? containerObject.attributes.hideQuickView : "false");
  const [productDetailsObj, setproductDetailsObj, productDetailsObjRef] = useStateRef('')
  const [cartProductDetails, setCartProductDetails] = useState('')
  const [productCount, setProductCount, productCountRef] = useStateRef('')

  const handleQuickViewProductPage = (event) => {
    event.preventDefault()
    setproductDetailsObj('')
    setProductCount('')
    var formData = new FormData(event.target);
    const productId = formData.get("productIds")
    const productCount = formData.get("productCount")
    fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
      method: 'GET'
    }).then(res => res.json())
      .then(res => {
        if (res !== null) {
          console.log('hiddenSharePageModalFeaturedItem response ==== ', res)
          var productDetatils = (JSON.parse(res.response)).response
          setproductDetailsObj(productDetatils)
          setProductCount(productCount ? productCount : "")
          console.log('product-quick-view start')
          var modalElement = document.getElementById(`${productId ? productId : "quickViewModal"}`);
          var bootstrapModal = new bootstrap.Modal(modalElement);
          bootstrapModal.show();
          console.log('product-quick-view end')
        } else {
          //don't do anythink
        }
      })
  }

  const cartProductDetailsCallBack = (productDetails) => {
    setCartProductDetails(productDetails)
  }

  function replaceImage(event) {
    event.target.src = DEFAULT_IMAGE_140;
  }

  return (
    <>
      {featuredItems ? featuredItems.map((featuredItem, index) => {
        return (
          <>
            <div class={`fetaured-justifiy-content-center ${containerObject && containerObject.attributes && containerObject.attributes.colPerRowSizeForGridView ? containerObject.attributes.colPerRowSizeForGridView : "col-6 col-md-3"}`}>
              <div class="cb-feature-product qv-model">
                <Link to={featuredItem["productUrl"]} class="c-product-link">
                  {containerObject.attribute && containerObject.attributes.imageFetchPriortityAttr && containerObject.attributes.imageFetchPriortityAttr == "lazy" ?
                    <img alt={featuredItem["product.productName"] ? featuredItem["product.productName"] : ""} onError={replaceImage} src={`${featuredItem["product.smallImageUrl"]}` ? `${featuredItem["product.smallImageUrl"]}` : ""} class="c-product-img" loading="lazy" />
                    :
                    <img alt={featuredItem["product.productName"] ? featuredItem["product.productName"] : ""} onError={replaceImage} src={`${featuredItem["product.smallImageUrl"]}` ? `${featuredItem["product.smallImageUrl"]}` : ""} class="c-product-img" fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} />}
                  <h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: featuredItem["product.productName"] ? featuredItem["product.productName"] : "" }}>
                  </h3>
                </Link>
                {featuredItem["product.mediaType"] ? "" :
                  <div className="">
                    {featuredItem["product.familyProduct.count"] ? <p class="c-product-total">{featuredItem["product.familyProduct.count"]}&nbsp; Products</p> : featuredItem["product.productId"] ? <p class="c-product-total">Item #{featuredItem["product.productId"] ? featuredItem["product.productId"] : ""}</p> : ""}
                    {profileDetails && profileDetails.call_for_pricing ? <p class="c-product-price">{profileDetails.call_for_pricing}</p> :
                      <p class="product-price">
                        {profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price cb-call-for-price">{profileDetails.call_for_pricing}</p> :
                          profileDetails && profileDetails.userType == "2" ?
                            <>
                              {featuredItem.retailPrice != null && featuredItem.retailPrice != undefined ?
                                featuredItem.contractPrice ?
                                  <span class="contract-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span> :
                                  <div class="prod-contract-disc">
																					<div class="prod-contract-price">
																						<span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
																					</div>
																				</div>
                                : featuredItem.contractPrice && featuredItem.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</p> <span class="c-product-price-value">{featuredItem.contractPrice ? featuredItem.contractPrice : ""}</span></div> :
                                <div class="prod-contract-disc">
                                    <div class="prod-contract-price">
                                        <span class="contract-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : ""}</span>
                                    </div>
                                </div>}

                              {featuredItem.retailPrice && featuredItem.retailPrice != "$0.00" ?
                                <div class="prod-retail-price">
                                  Retail<span class="list-price-value">{featuredItem.retailPrice}</span>
                                </div> : ""}
                            </> :
                            <>{featuredItem.oldPrice && featuredItem.itemPrice ? <div className="d-flex">
                              <p class={`list-price-value mx-1`}>{featuredItem.oldPrice ? featuredItem.oldPrice : ""}</p><span class="c-product-price-value">{featuredItem.itemPrice ? featuredItem.itemPrice : featuredItem["product.productId"] && featuredItem["product.productId"].includes("FAM") ? "0.00 - 0.00" : "0.00"}</span></div>
                              : <p class={`${featuredItem.oldPrice ? "list-price-value mx-1" : "c-product-price"} `}>{featuredItem.qtyRange ? featuredItem.qtyRange : featuredItem.itemPrice ? featuredItem.itemPrice : featuredItem["product.productId"] && featuredItem["product.productId"].includes("FAM") ? "0.00 - 0.00" : "0.00"}</p>} </>}
                      </p>}
                  </div>}
                {profileDetails && profileDetails.call_for_pricing ? "" : <div className="">
                  {featuredItem && featuredItem.qtyDiscountAvailable && featuredItem.qtyDiscountAvailable == true ? <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
                </div>}
                {featuredItem.reviewURLAverage ?
                <div class="c-product-rating">
                  {containerObject.attribute && containerObject.attributes.imageFetchPriortityAttr && containerObject.attributes.imageFetchPriortityAttr == "lazy" ?
                    <img src={`/images/stars/50/rating-${featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""}_50.png`} alt={featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""} loading="lazy" />
                    :
                    <img src={`/images/stars/50/rating-${featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""}_50.png`} alt={featuredItem.reviewURLAverage ? featuredItem.reviewURLAverage : ""} fetchPriority={containerObject.attributes && containerObject.attributes.imageFetchPriortityAttr == "low" ? "low" : "high"} />}
                </div>:""}
                {featuredItem["product.mediaType"] ?
                  <p class="c-product-info">
                    <i title={featuredItem["product.mediaType"]} className={`${featuredItem["product.mediaType"] === "Document" ? "bi bi-filetype-pdf" : featuredItem["product.mediaType"] === "Interactive" ? "bi bi-link-45deg" : ""}`}></i>
                    {featuredItem["product.mediaType"]}
                  </p> :
                  quickView === "false" ? <>
                    <form onSubmit={handleQuickViewProductPage} className="" id={`quickViewModalForm${index}`}>
                      <input type="hidden" name="productIds" value={featuredItem["product.productId"]} id={`productObj${index}`} />
                      <input type="hidden" name="productCount" value={featuredItem["product.familyProduct.count"] ? featuredItem["product.familyProduct.count"] : ""} id={`productObj${props}`} />
                      <button type="submit" className="btn quick-btn modal-link" >Quick View</button>
                    </form>
                  </> : ""}
              </div>
            </div>
          </>
        )
      }) : ""}
      {productDetailsObjRef.current ? <>  <Link id="hiddenSharePageModalFeaturedItem" aria-current="page" data-bs-toggle="modal" data-bs-target="#quickViewModal"></Link>
        <ProductQuickViewModal productObj={productDetailsObjRef.current} solrValue={productCountRef.current} cartProductDetailsCallBack={cartProductDetailsCallBack} /> </> : ""}
    </>
  )
}

export default Product
